<template>
  <q-layout view="hHh Lpr fFf">
    <q-header class="bg-primary" bordered height-hint="98" reveal>
      <q-toolbar shrink>
        <q-btn dense flat round icon="mdi-menu" @click="toggleLeftDrawer" v-show="auth.token" class="q-mr-sm" />
        <router-link :to='{name:"home"}'>
          <q-btn flat round class="q-mr-sm">
            <q-avatar size="32px"><img alt="logo" src="@/assets/logo.svg" />
            </q-avatar>
          </q-btn>
        </router-link>
        <q-toolbar-title class="q-mr-sm">
          {{ $t('productID') }}
        </q-toolbar-title>
        <q-select
          v-model="locale"
          :options="localeOptions"
          :label="$t('language')"
          dense
          borderless
          emit-value
          map-options
          options-dense
          filled
          fill-input
          size="32px"
          style="min-width: 100px"
          class="q-mr-sm locale-select"
          dropdown-icon="mdi-menu-down"
          @update:model-value="changeLanguage"
        />
        <q-btn v-show="auth.token" class="q-mr-sm" flat>
          <q-avatar rounded size="32px">
            <q-icon color="white" name="mdi-account-cog" size="32px" />
          </q-avatar>
          <q-icon name="mdi-menu-down" size="16px" />

          <q-menu auto-close flat square>
            <q-list dense>
              <q-item class="GL__menu-link-signed-in">
                <q-item-section>
                  <div class="text-no-wrap">{{ $t('signedInAs') }} <span class="text-bold">{{ userName }}</span></div>
                </q-item-section>
              </q-item>
              <q-separator />
              <q-item class="GL__menu-link" clickable @click="toggleDarkMode">
                <div>
                  <q-icon color="blue-9" name="mdi-theme-light-dark" size="18px" />
                  {{ $t('darkMode') }}
                </div>
                <q-item-section />
              </q-item>
              <q-item class="GL__menu-link" clickable to="/tfa">
                <div>
                  <q-icon color="blue-9" name="mdi-two-factor-authentication" size="18px" />
                  {{ $t('TFA') }}
                </div>
                <q-item-section />
              </q-item>
              <q-item class="GL__menu-link" clickable to="/settings">
                <div>
                  <q-icon color="blue-9" name="mdi-tune" size="18px" />
                  {{ $t('settings') }}
                </div>
                <q-item-section />
              </q-item>
              <q-separator />
              <q-item class="GL__menu-link" clickable @click="auth.logout()">
                <div>
                  <q-icon color="blue-9" name="mdi-logout" size="18px" />
                  {{ $t('signOut') }}
                </div>
                <q-item-section />
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </q-toolbar>

      <q-tabs align="left">
        <div
          v-for="(route, index) in tabs"
          v-show="auth.token" :key="index">
          <q-route-tab
            v-show="(typeof route.meta !== 'undefined' && route.meta['visible'])"
            :label="$t(route.name?route.name.toString():'')"
            :to="{name:route.name}" />
        </div>
      </q-tabs>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" side="left" bordered>
      <!-- drawer content -->
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>

    <q-footer bordered class="bg-primary text-white">
      <q-toolbar>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { RouteRecordRaw } from 'vue-router';
import { RouterView, useRouter } from 'vue-router';
import { localeOptions } from '@/i18n';

import { useAuthStore } from '@/stores/auth';
import { useSettingsStore } from '@/stores/settings';
import { useI18n } from 'vue-i18n';
import { useQuasar } from 'quasar';

const { locale } = useI18n({ useScope: 'global' });

const routeSelector = ref('root');
const $q = useQuasar();

const auth = useAuthStore();
const settings = useSettingsStore();
const routes = useRouter().options.routes.find(matchesRoutes);
const tabs = ref(routes?.children ?? []);

const leftDrawerOpen = ref(settings.isSideBarVisible);

const userName = auth.access.dat.find((param) => param.Key === 'usr')?.Value ?? '';

function toggleLeftDrawer() {
  leftDrawerOpen.value = !leftDrawerOpen.value;
  settings.setSideBarVisible(leftDrawerOpen.value);
}

function matchesRoutes(route: RouteRecordRaw) {
  return route.name === routeSelector.value;
}

function toggleDarkMode() {
  $q.dark.toggle();
  settings.setDarkMode($q.dark.isActive);
}

function changeLanguage() {
  settings.setLocale(locale.value);
}
</script>
